module.exports = __webpack_public_path__ + "static/media/interac.079486b4.png";